import React from "react";
import ContainerWrapper from "../../../designSystem/organisms/ContainerWrapper";

import closeIcon from "assets/nav_close.svg";
import { LandingHeader } from "../../../designSystem/molecules/LandingHeader";
import {
  LandingHeaderImage,
  LandingHeaderSubtitle,
} from "../../../designSystem/molecules/LandingHeader/LandingHeader";

import "./ErrorScreen.scss"
import { ORDER_DETAILS as STRINGS } from "businesslogic/strings/ordersAuth";
import errorIcon from "../../../assets/error_icon.svg"

const ErrorScreen = () => {
  return (
    <ContainerWrapper
      dataAid={STRINGS.error.dataAid}
      className="oa-error-screen"
      headerProps={{
        leftIconSrc: closeIcon,
        onBackClick: window.close,
        hideMenuBar: true
      }}
    >
      <div className="oa-error-content">
        <LandingHeader variant="center" dataAid={STRINGS.error.landingHeader.dataAid}>
          <LandingHeaderImage
            imgSrc={errorIcon}
          />
          <LandingHeaderSubtitle align="center">
            {STRINGS.error.subtitle.text}
          </LandingHeaderSubtitle>
        </LandingHeader>
      </div>
    </ContainerWrapper>
  );
};

export default ErrorScreen;
